"use strict";
// BettingStructure.ts
//
// Contains the base class for the betting structure for the games. Each of its
// subclasses implements the specific rules and checks for that betting structure
Object.defineProperty(exports, "__esModule", { value: true });
exports.BettingStructure = void 0;
/**
 * The parent class for all bet options (No Limit, Spread Limit, Cap Limit, ... )
 */
class BettingStructure {
    constructor(prefs) {
        this.validatePositiveNumber(prefs.maxRaises, "maxRaises");
        this.maxRaisesCount = prefs.maxRaises;
        this.raiseMustBeAtLeastPreviousRaise =
            prefs.raiseMustBeAtLeastPreviousRaise;
    }
    // checks if the amount provided is a positive, non zero number
    validatePositiveNumber(number, field) {
        if ((!number && number !== 0) || number < 0) {
            throw new Error(`Not a valid value: ${number} provided for: ${field}`);
        }
    }
    validateRaises(bet, round) {
        // check if
        // 1. is actual raise
        // 2. the game allows for raises
        // 3. the number of raises has been exceeded
        if (bet.raise > 0 &&
            this.maxRaisesCount > 0 &&
            round.raisesCount >= this.maxRaisesCount) {
            throw new Error("Maximum amount of raises reached");
        }
        if (this.raiseMustBeAtLeastPreviousRaise &&
            bet.raise > 0 &&
            bet.raise < round.currentRaise) {
            throw new Error("New raise must be at least previous raise");
        }
    }
    validateBetSize(bet, round) {
        if (bet.amount + bet.personalInPot < round.currentBet) {
            throw new Error("newBet must at least reach the currentBet");
        }
    }
}
exports.BettingStructure = BettingStructure;
//# sourceMappingURL=BettingStructure.js.map